module.exports = __webpack_public_path__ + "media/student_v2/assets/images/night_sky-c8c3843688afaccadec0977b7461b79a.svg";